import React from 'react';
import { useNavigate } from 'react-router';

import { StyledLink } from '@/shared/components/ui/navigatable-link/navigatable-link.styled';
import { TNavigatableLinkProps } from '@/shared/components/ui/navigatable-link/navigatable-link.types';

export const NavigatableLink: React.FC<TNavigatableLinkProps> = ({
  to,
  children,
  replace = false,
  state,
  className,
  onClick,
  ...rest
}) => {
  const navigate = useNavigate();

  if (!to) {
    return <>{children}</>;
  }

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      onClick(e);
    }

    if (
      e.button === 0 &&
      !e.ctrlKey &&
      !e.metaKey &&
      !e.shiftKey &&
      !e.defaultPrevented
    ) {
      e.preventDefault();
      navigate(to, { replace, state });
    }
  };

  return (
    <StyledLink to={to} onClick={handleClick} className={className} {...rest}>
      {children}
    </StyledLink>
  );
};
